export default __webpack_public_path__ + "22da002504764c3cf297e89e6b386eb8.png";